export default __webpack_public_path__ + "static/media/profile1.384bd21a.svg";